import React from 'react';
import {withRouter} from "react-router-dom";
import { connect } from "react-redux";
import style from './Pagination.module.scss';
import {Row, Col, Button, Modal} from "react-bootstrap";
import * as propertyActions from "../../../../redux/action/property.action";

class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.state = {}
  };

  render() {
    const { propertiesCount, from = 0, length = 15 } = this.props;
    const startPage = from / length + 1;
    const totalPage = Math.ceil(propertiesCount / length);

    return (
      <Row className={`m-0 no-gutters`}>
        <Col xs={12} md={6}>
          <div className={`${style.page_number} d-flex align-items-center justify-content-md-end justify-content-center`}>
            <span>صفحه</span>
            <span>{startPage}</span>
            <span>از</span>
            <span>{totalPage}</span>
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div className={`${style.pagination} d-flex justify-content-center align-items-center`}>
            <button
                type="button"
                className={`btn btn-sm ${startPage === totalPage ? `btn-light ${style.blank}` : `btn-primary ${style.action}`} d-flex align-items-center justify-content-between`}
                onClick={() => {
                  if (startPage !== totalPage) {
                    this.props.setPagination(+from + +length);
                  }
                }}>
              <i className={'icon-arrow-left'} />
              <span>صفحه بعد</span>
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button
                type="button"
                className={`btn btn-sm ${startPage === 1 ? `btn-light ${style.blank}` : `btn-primary ${style.action}`} d-flex align-items-center justify-content-between`}
                onClick={() => {
                  if (startPage !== 1) {
                    this.props.setPagination(+from - +length);
                  }
                }}
            >
              <span>صفحه قبل</span>
              <i className={'icon-arrow-right'} />
            </button>
          </div>
        </Col>
        <Col xs={12}>
          <div className={style.pagination}>

          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  propertiesCount: state.property.propertiesCount,
  length: state.property.filter.length,
  from: state.property.filter.from,
});

const mapDispatchToProps = (dispatch) => ({
  setPagination: (from) =>  dispatch(propertyActions.setPagination(from)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Pagination));
